// CSS
import "./panels.css";

function ErrorPanel(props) {

    const getPromptButtons = () => {
        return props.Prompts?.filter(prompt => (prompt.Visible === undefined) || prompt.Visible).map((prompt, index) => {
            return (
                <button type="button" key={index} className="eone-ui-error-panel-link" onClick={prompt.OnClick}>
                    {prompt.Label}
                </button>
            );
        });
    }

    return (
        <div className="eone-ui-error-panel">
            {props.Image && <img src={props.Image} className="eone-ui-error-panel-image" alt={props.Title} />}
            <div className="eone-ui-error-panel-title">{props.Title}</div>
            <div className="eone-ui-error-panel-message">{props.Message}</div>
            <div className="eone-ui-error-panel-prompts">
                {getPromptButtons()}
            </div>
        </div>
    );
}

export { ErrorPanel };
